import styles from "./AppliedFiltersItem.module.scss";

interface AppliedFiltersItemProps {
  label: string;
  onRemove(): void;
}

const AppliedFiltersItem = ({ label, onRemove }: AppliedFiltersItemProps) => {
  return (
    <div className={styles.item} onClick={onRemove}>
      <div className={styles.label}>{label}</div>
      <div className={styles.resetIcon}>
        <img
          src="/static/img/icons-v6/cross.svg"
          alt={`убрать фильтр ${label}`}
        />
      </div>
    </div>
  );
};

export default AppliedFiltersItem;
